import { IDefineCommand, IQuery } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';

angular
  .module('capability-ng-conversations')
  .factory(
    'updateConversationStatusCommand',
    ($http: ng.IHttpService, defineCommand: IDefineCommand, accountModel: AccountModel) => {
      return defineCommand(
        'updateConversationStatusCommand',
        (deferred: ng.IDeferred<IQuery[]>, ids: number[], status: string) => {
          $http
            .patch(`notification/students/${accountModel.student_nk}/messages/?id__in=${ids.join()}`, { status })
            .then((): void => deferred.resolve());
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/commands/update_conversation_status_command.ts